export default "__VITE_ASSET__DMvQpN8z__"